import { LanguageCode, PlanCurrencyKind } from "shared";

export const RELATIVE_TIME_FORMATTER = new Intl.RelativeTimeFormat("en-US", { style: "narrow", numeric: "auto" });
export const DATE_FORMATTER_MEDIUM = new Intl.DateTimeFormat("en-US", { dateStyle: "medium" });
export const LANGUAGE_NAME_FORMATTER = new Intl.DisplayNames(["en"], { type: "language" });

export function formatTimeUnit(unit: Intl.RelativeTimeFormatUnit, amount: number) {
	return Intl.NumberFormat("en-us", {
		style: "unit",
		unit: unit,
		unitDisplay: "long"
	}).format;
}

export function formatDate(date: Date, formatter = DATE_FORMATTER_MEDIUM) {
	return DATE_FORMATTER_MEDIUM.format(date);
}

export function formatCurrency(amount: number, currency: PlanCurrencyKind) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		minimumFractionDigits: 0,
		currency: currency.toUpperCase()
	}).format(amount);
}

export function formatLanguage(language: LanguageCode) {
	try {
		return LANGUAGE_NAME_FORMATTER.of(language);
	} catch (error) {
		console.error(error);
		return language;
	}
}

export function getLanguageEmoji(language: LanguageCode) {
	switch (language) {
		case "en-US":
			return "🇺🇸";
		case "da-DK":
			return "🇩🇰";
	}
}
